import React, { Fragment, useEffect, useState } from 'react';
import EditClient from './EditClient';
import ClientInfo from './ClientInfo';
import NewClient from './NewClient';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import '../css/table-styles.css'
const ClientList = ({ is_admin }) => {

    const [clients, setClients] = useState([]);
    const [display_clients, setDisplay_clients] = useState([]);

    const [filter_name, setFilter_name] = useState("")
    const [filter_number, setFilter_number] = useState("")
    const [filter_active, setFilter_active] = useState(false)

    const getClients = async () => {
        try {
            const response = await fetch("https://www.beyondcommunityaccess.com/clients/all", {
                method: "GET",
                headers: { token: localStorage.token }
            });
            const jsonDataReq = await response.json();

            jsonDataReq.rows.map(client => {
                if (client.client_active === true) {
                    client.client_active_display = "Yes"
                } else {
                    client.client_active_display = "No"
                }
                client.description_display = client.client_description.substring(0, 10);
                if (client.client_description.length > 10) {
                    client.description_display += '...'
                }
            })
            setClients(jsonDataReq.rows);
            setDisplay_clients(jsonDataReq.rows);
        } catch (err) {
            console.error("Failed: getting all a user's shifts");
            console.error(err.message);
        }
    }

    const filter = async () => {
        try {

            setDisplay_clients(clients.filter(client => {
                var pass = true;
                if (filter_name !== "") {
                    if (!client.name.toLowerCase().includes(filter_name.toLocaleLowerCase()) && !client.client_id.toLowerCase().includes(filter_name.toLocaleLowerCase()))
                        pass = false;
                }
                if (filter_number !== "") {
                    if (!client.ndis_number.toLowerCase().includes(filter_number.toLocaleLowerCase()))
                        pass = false;
                }
                if (filter_active) {
                    if (!client.client_active) {
                        pass = false
                    }
                }
                return pass;
            }))

        } catch (err) {
            console.error("Failed: filtering clients");
            console.error(err.message);
        }
    }

    useEffect(() => {
        getClients();
    }, [])
    useEffect(() => {
        filter();
    }, [filter_name, filter_number, filter_active])
    return (
        <div className="container">
            <Fragment>
                <h1 className="m-2 d-inline-block">Client List</h1>
                {is_admin===2 && <NewClient refresh_clients={getClients} />}
                <h5 className="ml-2">Filters:</h5>
                <input className="form-control m-1" type="text" placeholder="Name" value={filter_name} onChange={e => setFilter_name(e.target.value)} />
                <input className="form-control m-1" type="text" placeholder="NDIS Number" value={filter_number} onChange={e => setFilter_number(e.target.value)} />

                <input placeholder="Active" type="checkbox" className="form-check-input ml-2 mt-2" id="active_filter_check" value={filter_active} onChange={e => setFilter_active(e.target.checked)} />
                <label className="form-check-label ml-5 mt-1" htmlFor="active_filter_check">
                    Active
                </label>

                <Table className="table mt-5 text-center">
                    <Thead>
                        <Tr>
                            <Th>Internal Client ID</Th>
                            <Th>NDIS Number</Th>
                            <Th>Name</Th>
                            <Th>Description</Th>
                            <Th>Active?</Th>
                            {is_admin >= 1 && <Th>Expand</Th>}
                            {is_admin === 2 && <Th>Edit</Th>}
                            {/* {is_admin === 2 && <Th>Make Inactive</Th>} */}

                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>John</Td>
                        <Td>Doe</Td>
                        <Td>john@example.com</Td>
                    </Tr> */}
                        {display_clients.map(client => (
                            <Tr key={client.client_id}>
                                <Td>{client.client_id}</Td>
                                <Td>{client.ndis_number}</Td>
                                <Td>{client.name}</Td>
                                <Td>{client.description_display}</Td>
                                <Td>{client.client_active_display}</Td>
                                {is_admin >= 1 && <Td><ClientInfo client={client} /></Td>}
                                {is_admin === 2 && <Td><EditClient this_client={client} refresh_clients={getClients} /></Td>}
                                {/* {is_admin === 2 && <Td><button className="btn btn-danger">Make Inactive</button></Td>} */}
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Fragment>
        </div >
    );
}

export default ClientList;

